<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <div v-show="show"
                                     class="alert alert-danger alert-dismissible fade show"
                                     role="alert">
                                    <span v-for="(err, index) in validation_errors" :key="index">
                                      {{ err[0] }} <br/>
                                    </span>
                                </div>
                                <form enctype="multipart/form-data" files="true" role="form">
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="title">Title <span class="c-required">*</span></label>
                                            <input type="text" v-model="monthly.title" v-validate="{ required: true }" id="title" name="title" class="form-control form-control-sm" placeholder="Report title/name"/>
                                            <div class="invalid-feedback">Please enter monthly report title or name</div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="file">File <span style="font-weight: 100;">*Previous file <a :href="monthly.file" target="_blank">click here</a></span></label>
                                            <input type="file" id="file" name="file" ref="file"
                                                   @change="getFile" accept=".docx,.doc,.pdf,.csv,.xlsx,.xls"  class="form-control form-control-sm"/>
                                            <div class="invalid-feedback">Monthly file is required</div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="month">Month <span class="c-required">*</span></label>
                                            <select v-model="monthly.month" v-validate="'required'" id="month" name="month" class="form-control form-control-sm">
                                                <option :value="''">Select One.</option>
                                                <option value="January">January</option>
                                                <option value="February">February</option>
                                                <option value="March">March</option>
                                                <option value="April">April</option>
                                                <option value="May">May</option>
                                                <option value="June">June</option>
                                                <option value="July">July</option>
                                                <option value="August">August</option>
                                                <option value="September">September</option>
                                                <option value="October">October</option>
                                                <option value="November">November</option>
                                                <option value="December">December</option>
                                            </select>
                                            <div  class="invalid-feedback">Please select month</div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="year">Year <span class="c-required">*</span></label>
                                            <select v-model="monthly.year" v-validate="'required'" id="year" name="year" class="form-control form-control-sm">
                                                <option :value="''">Select One.</option>
                                                <option value="2015">2015</option>
                                                <option value="2016">2016</option>
                                                <option value="2017">2017</option>
                                                <option value="2018">2018</option>
                                                <option value="2019">2019</option>
                                                <option value="2020">2020</option>
                                                <option value="2021">2021</option>
                                                <option value="2022">2022</option>
                                                <option value="2023">2023</option>
                                                <option value="2024">2024</option>
                                                <option value="2025">2025</option>
                                                <option value="2026">2026</option>
                                            </select>
                                            <div  class="invalid-feedback">Please select year</div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="submission_date">Submission Date <span class="c-required">*</span></label>
                                            <datepicker v-model="monthly.submission_date" v-validate="'required'" id="submission_date"  name="submission_date" :format="customSubmissionDate" placeholder="Submission Date"></datepicker>
                                            <div v-if="errors.has('submission_date')" class="text-danger" style="margin-top: 0.25rem; font-size: 0.75rem;">Submission date required</div>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="remarks">Remarks</label>
                                            <input type="text" v-model="monthly.remarks" id="remarks" name="remarks" class="form-control form-control-sm" placeholder="Enter remarks"/>
                                        </div>
                                    </div>
                                    <div  class="form-row">
                                        <div class="form-group col-md-6">
                                            <button class="btn btn-success waves-effect waves-light mr-2"
                                                    @click.prevent="update">Update
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
    import moment from "moment";
    import Datepicker from "vuejs-datepicker";
    import Multiselect from "vue-multiselect";

    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "Update Monthly Report",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, Datepicker, Multiselect},
        data() {
            return {
                title: "Update Monthly Report",
                items: [
                    {
                        text: 'Dashboard',
                        href: '/',
                    },
                    {
                        text: 'Monthly Report',
                        href: '/monthly/list',
                    },
                    {
                        text: 'Monthly Report',
                        active: true,
                    },
                ],
                monthly: {
                    title: "",
                    month: "",
                    year: "",
                    submission_date: "",
                    remarks: "",
                },
                file: "",
                validation_errors: {},
                show: false,
            };
        },

        mounted() {
            this.getMonthlyReport();
        },

        methods: {
            customSubmissionDate(date) {
                this.monthly.submission_date = moment(date).format("YYYY-MM-DD");
                return moment(date).format("YYYY-MM-DD");
            },
            update() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let formData = new FormData();
                        formData.append("file", this.file)
                        formData.append("title", this.monthly.title)
                        formData.append("month", this.monthly.month)
                        formData.append("year", this.monthly.year)
                        formData.append("submission_date", this.monthly.submission_date)
                        formData.append("remarks", this.monthly.remarks)
                        formData.append('_method', 'PUT')

                        http.post("api/monthlies/" + this.monthly.id, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "Content-type": "application/json"
                            }
                        })
                            .then(response => {
                                this.$bvToast.toast(response.data.message, {
                                    title: "Success",
                                    autoHideDelay: 5000,
                                    variant: "success"
                                });
                                this.$router.push("/monthly/list");
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            getMonthlyReport() {
                let monthly_id = this.$route.params.monthly_id;

                http.get("api/monthlies/" + monthly_id + "/edit").then(response => {
                    if (!response.data.error) {
                        this.monthly = response.data.monthly;
                    }
                });
            },
            getFile() {
                this.file = this.$refs.file.files[0];
                if (this.file.size > 10000000) {
                    this.$bvToast.toast("File size not greater then 10 MB", {
                        title: "Error",
                        autoHideDelay: 5000,
                        variant: "error"
                    });
                    this.file = "";
                }
            },
            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            }
        },
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
    .vdp-datepicker input {
        width: 100%;
        border-radius: 3px;
        border: 1px solid #ced4da;
        height: 30px;
        padding-left: 15px;
        color: #6b757d;
    }
</style>